module.exports = __webpack_public_path__ + "static/media/TimeTravelClue2.becc469e.png";